webpackJsonp([2],{

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(20);

var _components = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactStatic.withRouteData)(function (_ref) {
  var project = _ref.project;
  return _react2.default.createElement(
    _components.Container,
    { py: [5,, 6], maxWidth: 'large' },
    _react2.default.createElement(
      _reactStatic.Head,
      null,
      _react2.default.createElement(
        'title',
        null,
        'Will Hoag - Project - ',
        project.title
      ),
      _react2.default.createElement('meta', { name: 'description', content: 'A case study for ' + project.title + ' - ' + project.blurb })
    ),
    _react2.default.createElement(
      _components.Flex,
      { flexWrap: 'wrap', alignItems: 'center' },
      project.image && _react2.default.createElement(
        _components.Box,
        { mb: [4, 0], w: [1, 1 / 2, 1 / 3] },
        _react2.default.createElement(_components.Image, { src: project.image, alt: 'depiction of project called ' + project.title, borderRadius: 2 })
      ),
      _react2.default.createElement(
        _components.Box,
        { w: project.image ? [1, 1 / 2, 2 / 3] : 1, pl: project.image ? [0, 4,, 5] : 0 },
        _react2.default.createElement(
          _components.Flex,
          { flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'top' },
          _react2.default.createElement(
            _components.HeadingWithAnchor,
            { is: 'h1', mt: 0, mb: 2, mr: 4 },
            project.title
          ),
          project.launchdate && _react2.default.createElement(
            _components.Box,
            null,
            _react2.default.createElement(_components.DateBox, { preText: 'Launched', dateFormat: 'yyyy', date: project.launchdate, my: 2 })
          )
        ),
        project.blurb && _react2.default.createElement(
          _components.HeadingWithAnchor,
          { is: 'h2', fontSize: 3 },
          project.blurb
        ),
        project.description && _react2.default.createElement(
          _components.Text,
          { is: 'p', fontSize: 3 },
          project.description
        ),
        project.url && _react2.default.createElement(
          _components.A,
          { href: project.url, target: '_blank' },
          'Visit Site'
        )
      )
    )
  );
});

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/Project.83c65fa3.js